import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Typography } from '@mui/material';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function SelectVariants({
    options,
    value,
    onChange,
    sx = { minWidth: 120 },
}) {
    return (
        <FormControl variant="standard" sx={sx}>
            <Select
                value={value}
                IconComponent={(props) => (
                    <ArrowDropDownIcon {...props} sx={{ color: "#1976d2 !important" }} />
                )}
                onChange={(e) => onChange(e)}
                sx={{
                    appearance: "none",
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    background: "transparent",
                    border: "none",
                    color: "#131C2B",
                    padding: "0 5px",
                    cursor: "pointer",
                    outline: "none",
                    fontWeight: "600",

                    // 🔹 Make sure displayed value is bigger
                    "& .MuiSelect-select": {
                        fontSize: "1.2rem",
                        fontWeight: "600",
                    },
                    "& .MuiInputBase-input": {
                        fontSize: "1.2rem",
                        fontWeight: "600",
                    },
                    "& .MuiTypography-root": {
                        fontSize: "1.2rem",
                        fontWeight: 600,
                        minWidth: "30px",
                        width: "10px"
                    }
                }}
                variant="standard"
                disableUnderline
                MenuProps={{
                    PaperProps: {
                        sx: {
                            borderRadius: "8px",
                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                            "& .MuiMenuItem-root": {
                                padding: "8px 16px",
                            },
                            "& .Mui-selected": {
                                backgroundColor: "#E3F2FD !important",
                                fontWeight: "bold",
                                borderLeft: "4px solid red", // 🔹 Red left border
                                "& .MuiTypography-root": {
                                    color: "#1976d2",
                                    fontWeight: "bold",
                                },
                            },
                            "& .MuiMenuItem-root:hover": {
                                backgroundColor: "#F5F5F5",
                            },
                        },
                    },
                }}
            >
                {options.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                        <Typography>{opt.label}</Typography>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}